export default {"src":"/_next/static/media/circleExclamationMarkUiRedWithLightRedBg_64.14e4b8f1.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};